module.exports = __webpack_public_path__ + "img/pem_33_reset.dc384846.png";